import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';

export interface cartState {
  data: [] | null;
}

const initialState: cartState = {
  data: null,
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.data = action.payload;
    },
    addNewCart: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    resetCartData: (state) => {
      state.data = null;
    },
  },
});

export const { setCart, addNewCart, resetCartData } = cartSlice.actions;

export const getCartData = (state: RootState) => state.cart.data;

export default cartSlice.reducer;